import { APIService } from '../api/APIService';
import { AxiosPromise } from 'axios';
import { CardholderDetails } from '../../redux/payment/payment';

export class BookingService {
    hostname: string;
    bookingPath = '/booking';
    paymentPath = '/payment';
    getPath = '/get';

    apiService: APIService;

    constructor(apiService: APIService) {
        const hostname = import.meta.env.VITE_DS_BOOKING_API;
        if (!hostname) {
            throw new Error('No booking uri set');
        }
        this.hostname = hostname;
        this.apiService = apiService;
    }

    // tslint:disable-next-line: max-line-length
    getPayment(productId: number, orderId: string, cardHolderDetails: CardholderDetails): AxiosPromise<endpoints.Payment> {
        const params = { productId, orderId, cardHolderDetails };
        // tslint:disable-next-line: max-line-length
        return this.apiService.postData(`${this.hostname}${this.bookingPath}${this.paymentPath}${this.getPath}`, params);
    }

    postBooking(booking: endpoints.BookingRequest): AxiosPromise<endpoints.BookingResponse> {
        const config = {
            timeout: 180000
        };
        return this.apiService.postData(`${this.hostname}${this.bookingPath}`, booking, config);
    }
}